'use client'

import { useRouter } from 'nextjs-toploader/app'
import { useEffect } from 'react'

export default function SignInRedirect() {
  const router = useRouter()

  // Client-side redirect that preserves the exact current URL as redirect target.
  useEffect(() => {
    const currentUrl = window.location.href
    router.replace('/auth/login?redirectUrl=' + encodeURIComponent(currentUrl))
  }, [router])

  return null
}
